import React, {
  FC, HTMLProps, ReactNode
} from 'react';
import clsx from 'clsx';

import {
  Spinner
} from '../Spinner';

import * as Style from './Switcher.styles';

interface SwitcherProps {
  isActive: boolean;
  onChange: () => void;
  switcherClassName?: HTMLProps<HTMLDivElement>['className'];
  labelClassName?: HTMLProps<HTMLLabelElement>['className'];
  label?: ReactNode;
  isLoading?: boolean;
}

export const Switcher: FC<SwitcherProps> = ({
  isActive,
  onChange,
  switcherClassName,
  labelClassName,
  label,
  isLoading,
}) => {
  return (
    <label
      className={clsx(
        'flex gap-2 font-medium text-15-20 text-dark-gray items-center',
        labelClassName,
      )}
    >
      <input
        type="checkbox"
        checked={isActive}
        onChange={onChange}
        className="hidden"
        disabled={isLoading}
      />

      <Style.Wrapper>
        <Style.SwitcherContainer
          $isActive={isActive}
          className={switcherClassName}
        />

        {isLoading && (
          <Style.SpinnerContainer $isActive={isActive}>
            <Spinner
              size={24}
              centered={false}
              color="inherit"
            />
          </Style.SpinnerContainer>
        )}
      </Style.Wrapper>

      {label && <span>{label}</span>}
    </label>
  );
};
